export default {
  labels: {
    today: "Aujourd'hui",
    pickup_time: 'Heure de retrait',
    delivery_time: 'Heure de livraison',
  },
};
